<template>
  <div>
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-handover" id="bb-handover-pdf">
      <div class="bb-handover__padding bb-handover__padding_top"
           :class="{'bb-handover__padding_top_pdf': hideForPdf}"/>
      <div class="bb-handover-header">
        <img class="bb-handover-header__logo" :src="companyLogo"/>
        <div class="bb-handover-header-details">
          <p class="bb-handover-header-details-line" v-for="detail in headerDetails" :key="detail">
            {{detail}}
          </p>
        </div>
        <div class="bb-handover-header__date">
          <div v-if="hideForPdf">{{formatDate}}</div>
          <DataPicker @setDate="setDate"
                      :default-date="date"
                      :format="'MMM DD, YYYY'" v-else/>
        </div>
      </div>
      <h2 class="bb-handover-title">{{title}}</h2>
      <div class="bb-handover-confirm">
        <p class="bb-handover-confirm__paragraph"
           :class="{'bb-handover-confirm__paragraph_inline': hideForPdf}">
          <span>I undersigned, </span>
          <span v-if="hideForPdf">{{client}},</span>
          <label class="bb-handover-label bb-handover-label_confirm" v-else>
            <input class="bb-input bb-input_border bb-input_border_dark
                      bb-handover-confirm-input bb-handover-confirm-input_client"
                   :class="{'bb-input_error': errors.client}"
                   @focus="clearError('client')"
                   v-model="client"
                   type="text">
            <transition name="fade">
              <span class="bb-handover-label__error" v-if="errors.client">
                {{errors.client}}
              </span>
            </transition>
            <span>{{space}}, </span>
          </label>
          <span>holder of</span>
          <span v-if="hideForPdf">{{country}}</span>
          <input class="bb-input bb-input_border bb-input_border_dark
                      bb-handover-confirm-input bb-handover-confirm-input_country"
                 v-model="country"
                 v-else
                 type="text">
          <span>passport no.</span>
          <span v-if="hideForPdf">{{passport}},</span>
           <input class="bb-input bb-input_border bb-input_border_dark
                         bb-handover-confirm-input bb-handover-confirm-input_passport"
                  v-else
                  v-model="passport"
                  type="text">
          <span v-if="!hideForPdf">,</span>
        </p>
        <p class="bb-handover-confirm__paragraph"
           :class="{'bb-handover-confirm__paragraph_inline': hideForPdf}">
          <span>hereby confirm that I have {{clientText}} the below mentioned list of original documents:</span>
        </p>
      </div>
      <transition-group name="list-complete" tag="div" class="bb-handover-documents">
        <div class="bb-handover-documents-item"
             :class="{
               'bb-handover-documents-item_last': index === documents.length - 1
             }"
             v-for="(doc, index) in documents"
             :key="doc.id" >
          <span class="bb-handover-documents-item__count">{{index + 1}}.</span>
          <span class="bb-handover-documents-item__label">{{doc.label}}</span>
          <i class="icon-trash-1 bb-icon bb-icon_red" @click="removeDoc(doc.id)" v-if="!hideForPdf"/>
        </div>
      </transition-group>
      <div class="bb-handover-confirm">
        <div class="bb-handover-confirm__paragraph"
             :class="{'bb-handover-confirm__paragraph_inline': hideForPdf}">
          <span>I,</span>
          <span v-if="hideForPdf">{{user.username}}, </span>
          <div class="bb-handover-confirm-input bb-handover-confirm__select" v-else>
            <BBSelect :label="userInput.labelList"
                      :error="errors[userInput.model]"
                      :placeholder="userInput.placeholder"
                      :searchable="userInput.searchable"
                      :options="userInput.list"
                      :clearable="userInput.clearable"
                      :value="user"
                      @dropdownOpen="changeSelectStatus"
                      @change="setSelect"/>
          </div>
          <span v-if="!hideForPdf">,{{space}}</span>
          <span>hereby certify that I have {{userText}}</span>
        </div>
        <div class="bb-handover-confirm__paragraph"
             :class="{'bb-handover-confirm__paragraph_inline': hideForPdf}">
          <span v-if="hideForPdf">{{client}}</span>
          <label class="bb-handover-label bb-handover-label_confirm bb-handover-label_confirm_start-line" v-else>
            <input class="bb-input bb-input_border bb-input_border_dark
                      bb-handover-confirm-input bb-handover-confirm-input_client"
                   :class="{'bb-input_error': errors.client}"
                   @focus="clearError('client')"
                   v-model="client"
                   type="text">
            <transition name="fade">
              <span class="bb-handover-label__error" v-if="errors.client">
                {{errors.client}}
              </span>
            </transition>
          </label>
          <span>holder of</span>
          <span v-if="hideForPdf">{{country}}</span>
          <input class="bb-input bb-input_border bb-input_border_dark
                      bb-handover-confirm-input bb-handover-confirm-input_country"
                 v-model="country"
                 v-else
                 type="text">
          <span>passport no.</span>
          <span v-if="hideForPdf">{{passport}},</span>
          <input class="bb-input bb-input_border bb-input_border_dark
                      bb-handover-confirm-input bb-handover-confirm-input_passport"
                 v-model="passport"
                 v-else
                 type="text">
          <span v-if="!hideForPdf">, {{space}}</span>
          <span>as per above list.</span>
        </div>
      </div>
      <div class="bb-handover-sign">
        <div class="bb-handover-sign-item">
          <span v-if="hideForPdf">{{user.username}}</span>
          <div class="bb-handover-sign-item__input bb-handover-confirm__select" v-else>
            <BBSelect :label="userInput.labelList"
                      :error="errors[userInput.model]"
                      :placeholder="userInput.placeholder"
                      :searchable="userInput.searchable"
                      :options="userInput.list"
                      :clearable="userInput.clearable"
                      :value="user"
                      @dropdownOpen="changeSelectStatus"
                      @change="setSelect"/>
          </div>
        </div>
        <div class="bb-handover-sign-item">
          <span v-if="hideForPdf">{{client}}</span>
          <label class="bb-handover-label" v-else>
            <input class="bb-input bb-input_border bb-input_border_dark bb-handover-sign-item__input"
                   :class="{'bb-input_error': errors.client}"
                   @focus="clearError('client')"
                   v-model="client"
                   type="text">
            <transition name="fade">
              <span class="bb-handover-label__error" v-if="errors.client">
                {{errors.client}}
              </span>
            </transition>
          </label>
        </div>
      </div>
      <div class="bb-handover-bottom">
        <div class="bb-handover-bottom__company">Business Boutique DMCC</div>
        <button class="bb-button bb-handover-bottom__button" @click="validateForm" v-if="!hideForPdf">SAVE</button>
      </div>
      <div class="bb-handover-footer">
        <p class="bb-handover-footer-line" v-for="detail in footerDetails" :key="detail">
          {{detail}}
        </p>
      </div>
      <div class="bb-handover__padding bb-handover__padding_bot"/>
    </div>
  </div>
</template>

<script>
import {
  handoverDetails,
  handoverTitle,
  handoverClientText,
  handoverUserText,
  handoverFooter,
  handoverTypeId,
  handoverNamePdf
} from '@/constants/handover'
import moment from 'moment'
import BBSelect from '@/components/Main/Inputs/BBSelect'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import {find, get, cloneDeep, filter, startCase, findIndex, every} from 'lodash'
import defaultLogo from '@/assets/images/logo.png'
import UsersListApi from '@/api/UsersList/api'
import HandoverApi from '@/api/ContactHandover/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import JsPdf from 'jspdf'
import zoomLevel from 'zoom-level'

export default {
  name: 'ContactHandoverForm',
  props: ['selectedDocuments', 'type', 'handover'],
  components: {BBSelect, DataPicker, LoaderFly},
  data () {
    return {
      counter: 1,
      editMode: false,
      loaderRun: false,
      date: new Date(),
      client: '',
      country: '',
      passport: '',
      user: {},
      headerDetails: handoverDetails,
      footerDetails: handoverFooter,
      documents: [],
      errors: {
        user: false,
        client: false
      },
      userInput: {
        id: 'user',
        model: 'user',
        list: [],
        labelList: 'username',
        clearable: false,
        searchable: false,
        require: true
      },
      hideForPdf: false,
      space: String.fromCharCode(160)
    }
  },
  computed: {
    nameForPdf () {
      return handoverNamePdf[this.type]
    },
    formatDate () {
      return moment(this.date).format('MMM DD, YYYY')
    },
    handoverDefinition () {
      return handoverTypeId[this.type]
    },
    title () {
      return handoverTitle[this.type]
    },
    clientText () {
      return handoverClientText[this.type]
    },
    userText () {
      return handoverUserText[this.type]
    },
    companyLogo () {
      const logo = get(this.company, 'image.path', '')
      return logo || defaultLogo
    },
    company () {
      const activeCompany = this.$store.getters.activeCompany
      const companiesList = this.$store.getters.companiesList
      return find(companiesList, {id: activeCompany})
    },
    clientInfo () {
      return this.$store.getters.clientInfo
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    }
  },
  methods: {
    getUserList ({limit, page, search}) {
      const searchWord = search ? `&search=${search}` : ''
      UsersListApi.getUsersList({limit, page, filter: searchWord})
        .then((resp) => {
          this.users = filter(resp.data.users, item => item)
          this.userInput.list = this.users.map(item => {
            item.username = startCase(item.username)
            return item
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    validateForm () {
      const errors = {
        client: this.client ? false : 'mandatory field',
        user: this.user.id ? false : 'mandatory field'
      }
      this.errors = errors
      const success = every(this.errors, (item) => item === false)
      if (success) {
        const handover = this.generateHandover()
        this.editMode ? this.updateHandover(handover) : this.createHandover(handover)
      }
    },
    generateHandover () {
      return {
        handoverDefinition: this.handoverDefinition,
        transferDate: this.date,
        client: this.clientInfo.id,
        confidant: {
          name: this.client,
          country: this.country,
          passportNo: this.passport
        },
        user: this.user.id,
        clientDocuments: this.documents.map(item => item.id),
        approved: false
      }
    },
    updateHandover (handover) {
      handover.id = this.handover.id
      this.loaderRun = true
      HandoverApi.updateHandover(handover)
        .then((resp) => {
          this.$emit('update', resp.data)
          this.hideForPdf = true
          this.$nextTick(this.generatePdf)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    createHandover (handover) {
      this.loaderRun = true
      HandoverApi.createHandover(handover)
        .then(() => {
          this.hideForPdf = true
          this.$nextTick(this.generatePdf)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    calcHeightPdf (elem) {
      const maxHeightA4 = this.calcMaxHeightA4()
      let realHeight = elem.clientHeight
      if (elem.clientHeight > maxHeightA4) {
        let i = 99
        while (i > 2 && (elem.clientHeight * (i * 0.01)) > maxHeightA4) {
          elem.style.transform = `scale(0.${i})`
          i--
        }
        realHeight = elem.clientHeight * (i * 0.01)
        const top = elem.clientHeight - realHeight - 15
        elem.style.top = `-${top / 2}px`
      }
      return realHeight
    },
    getCounterHandovers () {
      const clientId = this.clientInfo.id
      HandoverApi.getHandoverCounter(clientId)
        .then((resp) => {
          const result = {
            received: resp.data.handoverCounter,
            returned: resp.data.returnCounter
          }
          this.counter = result[this.type] + 1
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    calcMaxHeightA4 () {
      let dpi = document.createElement('div')
      dpi.style.width = '1cm'
      dpi.style.height = '1cm'
      dpi.style.position = 'fixed'
      dpi.style.top = '-100%'
      dpi.style.left = '-100%'
      dpi.style.zIndex = '-1'
      document.body.appendChild(dpi)
      const result = 27 * dpi.clientHeight
      dpi.remove()
      return result
    },
    prepareHandoverNode () {
      const contentHtml = document.getElementById('bb-handover-pdf').cloneNode(true)
      contentHtml.style.position = 'fixed'
      contentHtml.style.top = '0'
      contentHtml.style.left = '0'
      contentHtml.style.padding = '1.5cm'
      contentHtml.style.width = '21cm'
      contentHtml.style.zIndex = -1
      contentHtml.style.backgroundColor = '#FFFFFF'
      document.body.appendChild(contentHtml)
      return contentHtml
    },
    async generatePdf () {
      const contentHtml = await this.prepareHandoverNode()
      this.hideForPdf = false
      const fileName = this.nameForPdf + this.counter + '.pdf'
      const realWidth = contentHtml.clientWidth
      const realHeight = this.calcHeightPdf(contentHtml)
      const doc = new JsPdf({
        orientation: 'p',
        unit: 'pt',
        format: [realWidth * zoomLevel(), realHeight * zoomLevel()],
        putOnlyUsedFonts: true,
        compress: true
      })
      doc.html(contentHtml, {
        callback: (pdf) => {
          pdf.deletePage(2)
          pdf.save(fileName)
          contentHtml.remove()
          this.loaderRun = false
          this.$emit('close', true)
        }
      })
    },
    setDate (date) {
      this.date = date
    },
    removeDoc (idDoc) {
      const index = findIndex(this.documents, {id: idDoc})
      if (index !== -1) {
        this.documents.splice(index, 1)
      }
      if (this.documents.length === 0) {
        this.closeHandover()
      }
    },
    clearError (model) {
      this.errors[model] = false
    },
    setSelect (data) {
      this.user = data
    },
    changeSelectStatus () {
      this.errors.user = false
    },
    closeHandover () {
      this.$emit('close')
    },
    setValuesEditHandover () {
      this.editMode = true
      this.client = get(this.handover, 'confidant.name', '')
      this.country = get(this.handover, 'confidant.country', '')
      this.passport = get(this.handover, 'confidant.passportNo', '')
      this.user = get(this.handover, 'user', {})
      this.date = get(this.handover, 'transferDate', new Date())
    }
  },
  beforeMount () {
    this.documents = cloneDeep(this.selectedDocuments)
    if (this.handover) this.setValuesEditHandover()
    this.getUserList({})
    this.getCounterHandovers()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-handover {
    @include global-font;
    padding: 0 35px;
    width: 771px;

    &-header {
      display: grid;
      grid-column-gap: 50px;
      grid-template-columns: 1fr 1fr;
      justify-content: space-between;
      margin-bottom: 35px;

      &__logo {
        width: 98px;
        height: 98px;
        object-fit: cover;
        border-radius: 50%;
      }

      &-details {
        display: grid;
        grid-gap: 10px;
        font-weight: normal;
        font-size: 14px;
        grid-row: 1/3;
        grid-column: 2;

        &-line {
          text-align: right;
        }
      }

      &__date {
        margin-top: 30px;
        align-self: end;
        font-weight: 300;
        font-size: 13px;
        line-height: 16px;
      }
    }

    &-title {
      text-transform: uppercase;
      font-weight: 600;
      font-size: 14px;
      line-height: 151.34%;
      text-align: center;
      margin-bottom: 10px;
    }

    &-label {
      position: relative;
      display: flex;
      align-items: center;

      &_confirm {
        margin: 0 8px;

        &_start-line {
          margin-left: 0;
        }
      }

      &__error {
        position: absolute;
        right: 12px;
        color: $color-red-orange;
        font-size: 11px;
        line-height: 13px;
      }
    }

    &-confirm {
      font-weight: normal;
      font-size: 13px;

      &__select {
        display: inline-block;
        position: relative;
        width: 212px;
        height: 30px;
      }

      &__paragraph {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 16px;

        &_inline {
          line-height: 20px;
          display: inline;
        }
      }

      &-input {
        font-weight: normal;
        font-size: 13px;
        margin: 0 8px;

        &_client {
          margin: 0;
          width: 180px;
        }

        &_country {
          width: 100px;
        }

        &_passport {
          width: 130px;
        }
      }
    }

    &-documents {
      display: grid;
      margin-bottom: 26px;

      &-item {
        display: grid;
        align-items: center;
        grid-template-columns: 22px 1fr 21px;
        grid-gap: 5px;
        font-size: 12px;
        line-height: 14px;
        padding: 10px 0 10px 8px;
        border-bottom: 1px solid $color-mercury;
        min-height: 42px;
        transition: all 0.4s;

        &_last {
          border-bottom: none;
        }

        &__count {
          font-weight: 500;
        }

        &__label {
          font-weight: normal;
        }
      }
    }

    &-sign {
      display: flex;
      justify-content: space-between;
      margin-top: 95px;
      margin-bottom: 37px;

      &-item {
        font-size: 13px;
        width: 212px;
        padding-top: 10px;
        border-top: 1px solid $color-mercury;

        &__input {
          font-size: 13px;
          width: 100%;
          margin: 0;
        }
      }
    }

    &-bottom {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      width: 100%;
      margin-bottom: 26px;

      &__company {
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
      }

      &__button {
        justify-self: end;
        width: 103px;
      }
    }

    &-footer {
      position: relative;
      padding-top: 20px;
      font-weight: normal;
      font-size: 11px;
      line-height: 13px;
      text-align: center;

      &:after {
        content: '';
        position: absolute;
        left: -35px;
        top: 0;
        height: 2px;
        width: calc(100% + 70px);
        background-color: $color-wild-sand;
      }
    }

    &__padding {
      position: sticky;
      width: 100%;
      background-color: $color-white;
      height: 20px;

      &_top {
        top: 0;
        height: 55px;

        &_pdf {
          height: 35px;
        }
      }

      &_bot {
        bottom: -1px;
        height: 20px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactHandovers/ContactHandoverForm/ContactHandoverForm.vue